/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Header_PrdsInputs */

const en_header_prds = /** @type {(inputs: Header_PrdsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} plans`)
};

const id_header_prds = /** @type {(inputs: Header_PrdsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rencana`)
};

/**
* | output |
* | --- |
* | "{count} plans" |
*
* @param {Header_PrdsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const header_prds = /** @type {((inputs: Header_PrdsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_PrdsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_header_prds(inputs)
	return en_header_prds(inputs)
});